module.exports = __webpack_public_path__ + "img/emoji-question-eyes.75be43a6.svg";